import types from '../type/types.js'

export const resetEverything = () => ({
  type: types.RESET_EVERYTHING,
  payload: null
})

  export default {}